<script setup>
import {onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {useRouter} from "vue-router";
import {showSuccessMessage} from "../../helper";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import UserService from "@/services/UserService";
import CreateUpdateUserModal from "@/components/modals/CreateUpdateUserModal.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const router = useRouter();
const userId = router.currentRoute.value.params.id;
const user = ref({name: '', email: '', phone: ''});
const isLoading = ref(true);
const isGenerating = ref(false);

onMounted(() => {
  fetchUser();
});

function fetchUser() {
  isLoading.value = true;
  UserService.getUser(userId).then((response) => {
    user.value = response;
    isLoading.value = false;
  });
}

function navigateTo(to) {
  router.push(to);
}

function updateUser() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateUserModal, user.value ? {
    user: user.value,
  } : {});
  reveal();
  onConfirm((data) => {
    UserService.saveUser(data, userId).then(response => {
      showSuccessMessage(response.message);
      user.value = response.user;
    });
  });
  onCancel(() => {
  });
}


</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> Zpět</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
            {{ t('usersDetail.user_detail') }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
        </div>
      </div>

    </div>
    <div class="page-section__content">
      <div class="mb-4">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col">
                    <div class="card-header__title">
                      {{ t('usersDetail.basic_data') }}
                    </div>
                  </div>
                  <div class="col text-end">
                    <div class="card-header__action">
                      <Button :label="t('usersDetail.edit')" @click="updateUser()"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="info-table">
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('usersDetail.name') }}</span>
                    <span class="info-table__value col-12">{{ user?.name ?? '---' }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('usersDetail.email:') }}</span>
                    <span class="info-table__value col-12">{{ user?.email ?? '---' }}</span>
                  </div>
                  <div class="info-table__row row">
                    <span class="info-table__label col-12">{{ t('usersDetail.phone_number') }}</span>
                    <span class="info-table__value col-12">{{ user?.phone ?? '---' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
